module.exports = __webpack_public_path__ + "static/img/ci.d5b7172.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/ci.png
// module id = QaMV
// module chunks = 0